import React from "react";

/**
 * ─── Toolbar ──────────────────────────────────────────────────────────────
 * A horizontal action strip. Right-aligned by default; use `layout="between"`
 * to push groups to opposite ends with a spacer between.
 *
 * Props
 *   layout   "start" | "end" | "between"        (default "end")
 *   testId
 *   children — usually Buttons and/or Toolbar.Group / Toolbar.Spacer
 */
function Toolbar({ layout = "end", className = "", testId, children }) {
  const style = layout === "start" ? { justifyContent: "flex-start" }
             : layout === "end"    ? { justifyContent: "flex-end" }
             : undefined;
  const cn = ["ds-toolbar", layout === "between" && "ds-toolbar--between", className].filter(Boolean).join(" ");
  return <div className={cn} style={style} role="toolbar" data-testid={testId}>{children}</div>;
}

Toolbar.Group   = function ToolbarGroup({ children }) {
  return <div className="ds-toolbar__group">{children}</div>;
};
Toolbar.Spacer  = function ToolbarSpacer() {
  return <div className="ds-toolbar__spacer" aria-hidden />;
};

export default Toolbar;
